import Cookies from 'js-cookie';
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
};

var utm_cookie = {
  'date-time': new Date(),
  utm_campaign: getUrlParameter('utm_campaign'),
  utm_source: getUrlParameter('utm_source'),
  utm_medium: getUrlParameter('utm_medium'),
  utm_content: getUrlParameter('utm_content'),
  utm_term: getUrlParameter('utm_term'),
  utm_adgroup: getUrlParameter('utm_adgroup'),
  utm_creative: getUrlParameter('utm_creative'),
  gclid: getUrlParameter('gclid'),
};

if (utm_cookie.utm_campaign !== '') {
  Cookies.set('xmatters_utm_vars', utm_cookie, { expires: 90 });
}
utm_cookie =
  typeof Cookies.get('xmatters_utm_vars') !== 'undefined'
    ? JSON.parse(Cookies.get('xmatters_utm_vars'))
    : {};

var sessionReferrer = '';

// if this is a new session
if (typeof Cookies.get('session_referrer') == 'undefined') {
  sessionReferrer = document.referrer || 'n/a';
  Cookies.set('session_referrer', sessionReferrer);
} else {
  sessionReferrer = Cookies.get('session_referrer');
}

const xmattersEmailRegex = /@xmatters.com$/i;

export const isXmattersEmail = (email) => xmattersEmailRegex.test(email);

export const getSignupExp = () => {
  return getUrlParameter('signupExperience');
};

export const signupTemplate = {
  EVBG: {
    title: 'Everbridge Title',
    subtitle: 'Everbridge SubTitle',
    heroImg: '/assets/images/signup-intro.svg',
    formHeader: 'Everbridge FormHeader',
  },
  XM: {
    title: '2.7 million global users count on xMatters',
    subtitle:
      'Ensure service reliability. Get started with the free xMatters plan today!',
    heroImg: '/assets/images/signup-intro.svg',
    formHeader: 'No credit card required',
  },
};

export const onboardingTemplate = {
  EVBG: {
    title: 'Everbridge Title',
    subtitle: 'Everbridge SubTitle',
  },
  XM: {
    title: 'Just one more step!',
    subtitle:
      'We need a few final details to finish setting up your account...',
  },
};

export const getSignupContent = () => {
  const key = getSignupExp();
  return signupTemplate[key] || signupTemplate['XM'];
};

export const getOnboardingContent = () => {
  const key = getSignupExp();
  return onboardingTemplate[key] || onboardingTemplate['XM'];
};

const convertRegion = (region) => {
  switch (region) {
    case 'Americas':
      return 'NA';
    case 'EMEA':
    case 'APAC':
      return region;
    default:
      return undefined;
  }
};

export const substringParmeter = (param, len) => {
  if (!param) return param;
  return param.substring(0, len);
};

export const autoFill = () => {
  return {
    firstName: substringParmeter(getUrlParameter('firstName'), 100),
    lastName: substringParmeter(getUrlParameter('lastName'), 100),
    emailAddress: substringParmeter(getUrlParameter('companyEmail'), 254),
    companyName: substringParmeter(getUrlParameter('companyName'), 100),
    region: convertRegion(getUrlParameter('region')),
  };
};
